module.exports = __webpack_public_path__ + "img/big_1_65.e7ea9955.png";